import React, { useState, useEffect } from "react";
import "./InfoPopup.css";

import PopupLike from "../../images/popupLike.svg";

function InfoPopup(props) {
  const [infoActive, setInfoActive] = useState(false);
  const [infoActiveClose, setinfoActiveClose] = useState(false);

  const [infoPopupClose, setInfoPopupClose] = useState(false);
  const [infoPopupActive, setInfoPopupActive] = useState(false);

  useEffect(() => {
    if (props.open) {
      setInfoActive(true);
      setinfoActiveClose(true);
      setTimeout(() => {
        setInfoPopupActive(true);
        setInfoPopupClose(true);
      }, 1000);
    } else {
      setInfoPopupActive(false);
      setTimeout(() => {
        setInfoActive(false);
        setTimeout(() => {
          setinfoActiveClose(false);
          setInfoPopupClose(false);
        }, 1000);
      }, 1000);
    }
  }, [props.open]);

  return (
    <div
      className={`InfoPopup  ${
        infoActive ? "activeInfo" : infoActiveClose ? "infoclose" : "disactive"
      }`}
    >
      <div
        className={`InfoPopup__popup ${
          infoPopupActive
            ? "activeInfoPopup"
            : infoPopupClose
            ? "infoPopupclose"
            : "disactive"
        }`}
      >
        {props.info && (
          <>
            <p className="InfoPopup__popup__titlesign">
              Увы. Сбросить пароль можно только через главного администратора
            </p>
            <p className="InfoPopup__popup__subtitlesign">
              Самостоятельно сбросить неполучится. Вам необходимо запросить
              разрешения у главного администратора для сброса пароля.
            </p>
          </>
        )}
        <div className="InfoPopup__popup__btn">
          <button onClick={() => {
            props.setOpen(false)
          }} type="button" className="InfoPopup__popup__btn__btn">
            <img alt="icon" src={PopupLike} />
            Теперь понятно
          </button>
        </div>
      </div>
    </div>
  );
}

export default InfoPopup;
